<template>
  <div class="material-select-box">
    <template v-if="filters.isBatchSelect">


      <template v-if="filters.type == 3">
        
        <a-space size="large" style="margin-top: 15px;">
          <a-button class="upload" style="width:260px"  type="dashed" :icon="'select'" @click="buttonClick" v-if="materials!=undefined &&  filters.num > materials.length">
            <b v-if="materials!=undefined &&  materials.length>0"> 已选择 {{materials.length}}/{{ filters.num }} 个视频 </b>
            <b v-else> 点击添加素材 </b>
          </a-button>
    
          <a-button class="upload"  style="width:260px"  type="dashed" :icon="'select'" v-else>
            <b> 已选择 {{materials.length}}/{{ filters.num }} 个视频 </b>
          </a-button>
    
          <a-button type="danger" v-if="materials!=undefined &&  materials.length>0" @click="clearSelectMaterials()" >
            清除所有选中视频
          </a-button>
        </a-space>

        <a-list v-if="materials!=undefined && materials.length>0" :grid="{ gutter: 16, column: 3 }" :data-source="materials">
          <a-list-item slot="renderItem" slot-scope="item">
            <!-- <a-card :title="item.name"> -->
            <a-card>
              <template slot="title">
                <a-tooltip :title="item.name">
                  <span>{{ item.name }}</span>
                </a-tooltip>
              </template>
              <template v-if="!simpleMode">
                <a-row type="flex">
                  <a-col :flex="1">
                    <video controls style="width:100px" :src="item.file_url"  ref="video"/>
                    <br> 
                    <a-button :icon="'delete'" @click="deleteImage(item)">
                      删除
                    </a-button>
                  </a-col>
                  <a-col :flex="3">
                    <img style="width:100px;height:auto !important;" :src="item.video_custom_cover?item.video_custom_cover:item.video_cover" /><br>
                    <a-tag color="green" class="video_select_tag">封面</a-tag>
                  </a-col>
                </a-row>
              </template>
              <template v-else>
                <a-button :icon="'delete'" @click="deleteImage(item)">
                  删除
                </a-button>
              </template>
            </a-card>
          </a-list-item>
        </a-list>

      </template>
     


      <template v-else >
        <div v-for="(item, index) in materials" :key="index" :value="item.file_url">
          <div  v-if="!item.file_url.includes('.mp4')">
            <img style="height:150px" :src="item.file_url" @click="preview(item)"/>
            <br> 
            <a-button :icon="'delete'" @click="deleteImage(item)">
              删除
            </a-button>
          </div>
         
          <div v-else>
            <a-row type="flex">
              <a-col :flex="3">
                <video controls style="height:150px" :src="item.file_url"  ref="video"/>
                <br> 
                <a-button :icon="'delete'" @click="deleteImage(item)">
                  删除
                </a-button>
              </a-col>
              <a-col :flex="3">
                <img style="height:150px" :src="item.video_custom_cover?item.video_custom_cover:item.video_cover" />
              </a-col>
            </a-row>
          </div>
        
       
        </div>
  
        <a-button class="upload"  type="dashed" :icon="'upload'" @click="buttonClick" v-if="filters.num > materials.length">
          点击选择素材
        </a-button>
      </template>
      
 
    </template>

    <template v-else>
      <a-button class="upload" v-if="!material.file_url" type="dashed" :icon="'upload'" @click="buttonClick">
        点击选择素材
      </a-button>
  
      <div v-else>  
        <img style="height:150px" :src="material.file_url" @click="preview" /><br>
        <a-button :icon="'delete'" @click="deleteImage">
          删除
        </a-button>
      </div> 
    </template>

    <a-modal :visible="previewImage?true:false" :footer="null" @cancel="closerPreviewImage">
      <img style="width:100%" :src="previewImage" />
    </a-modal>


    <a-modal 
      centered
      :title="`本地素材列表`"
      :width="'86%'"
      :mask-closable="false"
      :visible="showLocalMaterialForm"
      :bodyStyle="{ padding: 0 }"
      :footer="null"
      @cancel="close"
    >
        <local-material ref="localMaterial" style="margin:-10px 20px 10px 10px" :filters="filters"  @success="afterCloseLocalMaterialList"/>
    </a-modal>

  </div>
</template>

<style lang="less" scoped>
@import 'MaterialSelect';
</style>

<script>
import MaterialSelect from './MaterialSelect'
export default MaterialSelect
</script>
